import { render, staticRenderFns } from "./BatchResultManagerServerTable.vue?vue&type=template&id=3066950f"
import script from "./BatchResultManagerServerTable.vue?vue&type=script&lang=js"
export * from "./BatchResultManagerServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports